import React from "react";
import { Box, Typography, Switch } from "@mui/material";

const SettingTile = ({ label, checked, name, onChange, disabled }) => (
  <Box
    onClick={() => !disabled && onChange({ target: { name, checked: !checked } })}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      border: "1px solid",
      borderColor: checked ? "#1F1B45" : "#e0e0e0",
      backgroundColor: checked ? "rgba(31, 27, 69, 0.05)" : "#fafafa",
      borderRadius: 1.5,
      px: 1.5,
      py: 1,
      height: "100%",
      cursor: disabled ? "default" : "pointer",
      opacity: disabled ? 0.6 : 1,
      transition: "border-color 0.15s ease, background-color 0.15s ease",
      "&:hover": disabled ? undefined : { borderColor: "#1F1B45" },
    }}
  >
    <Typography
      variant="body2"
      sx={{
        fontWeight: checked ? 600 : 500,
        color: checked ? "#1F1B45" : "text.secondary",
      }}
    >
      {label}
    </Typography>
    <Switch
      size="small"
      checked={checked}
      onChange={onChange}
      name={name}
      color="primary"
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
    />
  </Box>
);

export default SettingTile;
